module.exports = __webpack_public_path__ + "img/四川天府新区白马寺启明社区幼儿园.bc112a40.jpg";